import * as React from 'react';
import {
    Box, Card, IconButton, Slider, Typography, CardMedia, Dialog,
    DialogContent,
    DialogTitle,

} from '@mui/material';

import './Studio.css';
import { generateSearchVideo, generateVideoId, getModelName } from "../../services/apiService"
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import { PlayArrow, Pause, Fullscreen } from '@mui/icons-material';
import { useVideoWebSocket } from "../../context/VideoWebSocket";
import { useCreditPoints } from '../../services/CreditPointsProvider';
import { showToast } from '../Toast/CommonToast';
import Popup from "../Popup/Popup";
import YouTubePopup from '../Popup/YouTubePopup/YoutubePopup';
import { VideoItem} from "../../services/types";
import FluidComponent from '../Reusable/FluidComponent';
import { useLocation } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import ScheduledPopup from '../Popup/YouTubePopup/ScheduledPopup';
interface VideoComponentProps {
    image: any | null;
    setImage: (value: string | null) => void;
    videoData?: any | null;
    prompt: string;
    setPrompt: (value: string) => void;
}


export default function VideoComponent({ videoData, prompt, setPrompt }: VideoComponentProps) {
  // Add viewType state for FluidComponent
  const [viewType, setViewType] = React.useState<'grid' | 'masonry'>('masonry');
    const videoRef = React.useRef<HTMLVideoElement | null>(null);
    const [playing, setPlaying] = React.useState(false);
    const [progress, setProgress] = React.useState(0);
    const [duration, setDuration] = React.useState(0);
    // api calling here all states
    const userId = localStorage.getItem("userId") || "userId";
    const [mainVideo, setMainVideo] = React.useState<string | undefined>(undefined);
    const [allSearchImages, setAllSearchImages] = React.useState<any>([]);
    const [videoImage, setVideoImage] = React.useState<any>([]);
    const [fullscreenPopup, setFullscreenPopup] = React.useState(false);
    const [modalPrompt, setModalPrompt] = React.useState<string>("");
    const [selectedPopupItem, setSelectedPopupItem] = React.useState<VideoItem | null>(null);
    const [sharePopup, setSharePopup] = React.useState<boolean>(false);
    const [selectedImageId, setSelectedImageId] = React.useState<string | null>(null);
    const [popupOpen, setPopupOpen] = React.useState(false);
    const [eventId, setEventId] = React.useState<any>("");
    const { fetchCreditPoints } = useCreditPoints();
    const [selectedVideoIndex, setSelectedVideoIndex] = React.useState<number>(0);
    const [viewPopupOpen, setViewPopupOpen] = React.useState<boolean>(false);
    const [publishedData, setPublishedData] = React.useState<any>(null);
    const location = useLocation();
     const { state } = location;
    // const navigate = useNavigate();
    const cinemotionText = location.pathname.startsWith('/studio/cinemotion')
    const photoTalksText = location.pathname.startsWith('/studio/photo-talks')
    const titlePage = cinemotionText ? 'Cinemotion' : photoTalksText ? 'PhotoTalks' : 'Podcasts';
    const [scheduledData, setScheduleData] = React.useState<any>(null);


    // Restore popup for the correct video id after redirect
React.useEffect(() => {
    const youtubeLocation = localStorage.getItem('youtubeId');
    const locationPage = localStorage.getItem('youtubeLocation');
    if (youtubeLocation && allSearchImages.length > 0 && locationPage && state?.popup) {
        const idx = allSearchImages.findIndex((item:any) => item._id === youtubeLocation);
        if (idx !== -1) {
            setSelectedVideoIndex(idx);
            setSharePopup(true);
            setSelectedPopupItem(allSearchImages[idx]);
        }
        localStorage.removeItem('youtubeLocation');
    }
}, [location.pathname, allSearchImages, state?.popup]);


    // Socket Functionality
    const { status, videoItem, socketPrompt,socketImage, generatedStatus, videoGenerated, responseData } = useVideoWebSocket();

  // isWsLoading for FluidComponent (true if status is IN_PROGRESS)
  const isWsLoading = status === 'IN_PROGRESS';

      const resetVideo = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
            setProgress(0);
            setPlaying(false);
            videoRef.current.pause();
        }
    };

  React.useEffect(() => {
            setMainVideo(videoData?.statusResponse?.payload?.video?.url || videoItem);
            setVideoImage(videoData?.inputData?.imageUrl || socketImage);
            setModalPrompt(videoData?.inputData?.prompt ||  socketPrompt);
            fetchCreditPoints(userId)
            if (responseData) {
              const responseArray = Array.isArray(responseData) ? responseData : [responseData];
            
              if (responseArray.length > 0) {
                setAllSearchImages((prev: any) => {
                  const filtered = prev.filter((item: any) => item.status !== "IN_PROGRESS");
                  return [...responseArray, ...filtered];
                });
              }
            }
  }, [
  status,
  videoItem,
  socketPrompt,
  socketImage,
  generatedStatus,
  videoGenerated,
  responseData,
  fetchCreditPoints,
  userId,
  videoData?.inputData?.imageUrl,
  videoData?.inputData?.prompt,
  videoData?.statusResponse?.payload?.video?.url
]);

    React.useEffect(() => { if (allSearchImages.length) setSelectedVideoIndex(0); }, [allSearchImages]);
     React.useEffect(() => {
            if (allSearchImages.length && allSearchImages[selectedVideoIndex]) {
                setMainVideo(allSearchImages[selectedVideoIndex].videoUrl || null);
                setVideoImage(allSearchImages[selectedVideoIndex].thumbnailUrl || null);
                    const published = allSearchImages[selectedVideoIndex]?.published;
            let youtubeDataArr: any[] = [];
            if (published && typeof published === 'object' && Array.isArray(published.youtube) && published.youtube.length > 0) {
                youtubeDataArr = published.youtube;
            }
            setPublishedData(youtubeDataArr);
            }
            // if (allSearchImages[selectedVideoIndex]?.status === 'ERROR') {
            //     // showToast(allSearchImages[selectedVideoIndex]?.projectStatusResponse?.errorMessage ||  'error');
            // }
        }, [selectedVideoIndex, allSearchImages, responseData]);
    

    const displayStatus = (() => {
      if (status === "OK") return "";
      if (status === "ERROR") return "Generation failed";
      if (status === "IN_PROGRESS") return "Generating your video...";
      return  videoGenerated || videoData?.isGenerated || generatedStatus ? "" : "";
    })();

    const handleOpenPopup = () => {
        setPopupOpen(true);
    }
    

    React.useEffect(() => {
        if (videoData || videoData?.statusResponse?.payload?.video?.url) {
            setMainVideo(videoData?.statusResponse?.payload?.video.url || videoData?.videoUrl);
            setVideoImage(videoData.inputData?.imageUrl);
            setModalPrompt(videoData.inputData?.prompt);
             if(videoData?.status === "ERROR"){
                 showToast(videoData?.statusResponse?.payload?.detail[0]?.msg || videoData?.statusResponse?.payload?.detail,'error')
               }
        }
    }, [videoData]);

   const togglePlayPause = async () => {
    if (videoRef.current) {
        const videoEl = videoRef.current;
        if (!videoEl.paused) {
            videoEl.pause();
            setPlaying(false);
        } else {
            try {
                await videoEl.play();
                setPlaying(true);
            } catch (error) {
                console.warn("Play request interrupted or blocked:", error);
            }
        }
    }
};

    const handleProgress = () => {
      if (videoRef.current) {
          const { currentTime, duration } = videoRef.current;
          if (!isFinite(currentTime) || !isFinite(duration) || duration === 0) return;
  
          setProgress((currentTime / duration) * 100);
      }
  };
  

    const handleSeek = (event: Event, newValue: number | number[]) => {
      if (videoRef.current) {
          const duration = videoRef.current.duration;
          if (!isFinite(duration)) return;
  
          const seekValue = Array.isArray(newValue) ? newValue[0] : newValue;
          videoRef.current.currentTime = (seekValue / 100) * duration;
          setProgress(seekValue);
      }
  };

    const handleLoadedMetadata = () => {
        if (videoRef.current) {
            setDuration(videoRef.current.duration);
        }
    };

    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
      const modelNames = async()=>{
            const mediaType = "video"
      
            try{
              const modelNameResponse = await getModelName(mediaType);
              setEventId(modelNameResponse?.data);
            }catch(error){
              console.error("Error fetching model name:", error);
            }
          }
      
          React.useEffect(()=>{
            modelNames();
          },[])

        

    // VideoSearch all images
   const handleallfetchimages = React.useCallback(async (eventIdRes: string) => {
    try {
        const payLoadSearch = {
            eventId: eventIdRes,
            userId: userId
        }
        const response = await generateSearchVideo(payLoadSearch);
        if (response.status === "success") {
          setAllSearchImages(response.data);
          setScheduleData( response?.scheduledYouTubeUpdates)
          // setScheduleData(dummyData)
        }
    } catch (error) {
        console.error("Error fetching video:", error);
    }
}, [userId]);
  React.useEffect(() => {
            if (eventId) {
              const eventIdRes = Array.isArray(eventId)
                ? eventId.find((item: any) => item?.eventName === "Cinemotion")?._id
                : null;
          
              if (eventIdRes) {
                handleallfetchimages(eventIdRes);
              }
            }
          }, [eventId, videoData,handleallfetchimages, sharePopup]);
    // React.useEffect(() => {
    //     handleallfetchimages();
        
    // }, [videoData]);
    React.useEffect(() => {
        if (allSearchImages.length && !videoImage) {
          setVideoImage(allSearchImages[0]?.inputData?.imageUrl);
            setMainVideo(allSearchImages[0]?.statusResponse?.payload?.video?.url || allSearchImages[0]?.videoUrl);
            setModalPrompt(allSearchImages[0]?.inputData?.prompt);
            setSelectedImageId(allSearchImages[0]._id);
             if(allSearchImages[0]?.status === "ERROR"){
                 showToast(allSearchImages[0]?.statusResponse?.payload?.detail[0]?.msg || allSearchImages[0]?.statusResponse?.payload?.detail,'error')
               }
        }
    }, [allSearchImages, videoImage]);

    //   handleVideosearcg

    const handleVideoSearch = async (id: any) => {
      resetVideo();
        try {
            const response = await generateVideoId(id);
            if (response.status === "success") {
                const videoUrl = response?.data?.statusResponse?.payload?.video?.url || response?.data?.videoUrl;
                const selectedPrompt = response?.data?.inputData?.prompt;
                setMainVideo(videoUrl);
                setVideoImage(response?.data.inputData?.imageUrl);
                setModalPrompt(selectedPrompt);
                setSelectedImageId(response.data._id);
               if(response?.data?.status === "ERROR"){
                 showToast(response?.data?.statusResponse?.payload?.detail[0]?.msg || response?.data?.statusResponse?.payload?.detail,'error')
               }
              }
        } catch (error) {
            console.error("Error fetching video:", error);
        }
    };
     const handleDownload = async () => {
         let fileUrl = mainVideo || "";
         if (!fileUrl.startsWith("http://") && !fileUrl.startsWith("https://") && !fileUrl.startsWith("/")) {
             showToast("Invalid file URL for download.", "error");
             return;
         }
         let fileName = fileUrl.split('/').pop()?.split('?')[0] || "podcast-video.mp4";
         if (!fileName.toLowerCase().endsWith('.mp4')) {
             fileName += '.mp4';
         }
         if (!mainVideo) {
             console.error("Missing video.");
             return;
         }
         try {
             const response = await fetch(mainVideo);
             const blob = await response.blob();
             const url = window.URL.createObjectURL(blob);
             const a = document.createElement("a");
             a.href = url;
             a.download = fileName;
             document.body.appendChild(a);
             a.click();
             document.body.removeChild(a);
             window.URL.revokeObjectURL(url);
         } catch (error) {
             console.error("Download failed:", error);
         }
     };
      const handleSharePopup = (item: any) => {
        setSharePopup(true);
        setSelectedPopupItem(item);
        localStorage.setItem('youtubeLocation', location.pathname)
        localStorage.setItem('youtubeId', item._id);
    }

    return (
      <Box className="videoComponentContainer">
        {allSearchImages.length > 0 ? (
          <Box sx={{position: 'relative'}}>
            {mainVideo ? (
              <Card className="videoCard">
                <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, flexDirection: 'row' }}>
                  <Box className=''>
                    <IconButton onClick={() => setViewPopupOpen(true)}>
                      <img src={'/assets/VideoEye.svg'} alt='viewIcon' className='viewIcon' />
                    </IconButton>
                  </Box>
                  <Box className="">
                    <IconButton onClick={handleDownload}>
                      <img
                        src={'/assets/DownloadIcon.svg'}
                        alt="downloadIcon"
                        className="downloadIcon"
                      />
                    </IconButton>
                  </Box>
                  <Box className=''>
                    <IconButton onClick={() => handleSharePopup(allSearchImages[selectedVideoIndex])}>
                      <img src={'/assets/ShareIcon.svg'} alt='shareIcon' className='shareIcon' />
                    </IconButton>
                  </Box>
                </Box>
                <Box className="videoWrapper">
                  <video
                    key={mainVideo}
                    ref={videoRef}
                    loop
                    muted
                    onTimeUpdate={handleProgress}
                    playsInline
                    onLoadedMetadata={handleLoadedMetadata}
                    poster={videoImage}
                  >
                    <source src={mainVideo ?? undefined} type="video/mp4" />
                  </video>
                </Box>
               
                                                                         {sharePopup && (
                                                <YouTubePopup
                                                        isOpen={sharePopup}
                                                        onClose={() => { setSharePopup(false); setSelectedPopupItem(null); }}
                                                        videoUrl={selectedPopupItem?.videoUrl || mainVideo || ''}
                                                        titlePage={titlePage}
                                                        selectedPopupItem={selectedPopupItem}
                                                    />    
                                                )}
                {/* <Box className="videoFooter">
                  <img
                    src={waterMarkImage}
                    alt="waterMarkIcon"
                    className="waterMarkIcon"
                  />
                </Box> */}
                <Box className="videoControls">
                  <IconButton onClick={togglePlayPause}>
                    {playing ? <Pause /> : <PlayArrow />}
                  </IconButton>
                  <Slider
                    value={progress}
                    onChange={handleSeek}
                    className="videoSlider"
                  />
                  <Typography variant="body2" className="videoTime">
                    {formatTime(duration)}
                  </Typography>
                  <IconButton onClick={() => setFullscreenPopup(true)}>
                    {" "}
                    {/* Open fullscreen popup */}
                    <Fullscreen />
                  </IconButton>
                  {fullscreenPopup && (
                    <Dialog
                      open={fullscreenPopup}
                      onClose={() => setFullscreenPopup(false)}
                      maxWidth="lg"
                      fullWidth
                      className="modalContainer"
                    >
                      <DialogTitle className="closeIconContainer">
                        <IconButton
                          onClick={() => setFullscreenPopup(false)}
                          className="closeIconbutton"
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent>
                        <Box
                          sx={{width: "100%",height: "60%",position: "relative",}}
                        >
                          <video
                            controls
                            autoPlay
                            loop
                            muted
                            className="modalVideo"
                            controlsList="nodownload"
                          >
                            <source src={mainVideo} type="video/mp4" />
                          </video>
                          <Box className="videoHeader">
                            <IconButton onClick={handleDownload}>
                              <img
                                src={'/assets/DownloadIcon.svg'}
                                alt="downloadIcon"
                                className="downloadIcon"
                              />
                            </IconButton>
                          </Box>
                          {/* <Box className="videoFooter">
                            <img
                              src={waterMarkImage}
                              alt="waterMarkIcon"
                              className="waterMarkIcon"
                            />
                          </Box> */}
                        </Box>
                        {/* <DialogTitle className="mainDialogTitle">
                          <Typography variant="body2">
                            {renderBracketedText(modalPrompt)}
                          </Typography>
                        </DialogTitle> */}
                      </DialogContent>
                    </Dialog>
                  )}
                </Box>
              </Card>
            ) : (
              <Box className="videoUploadCard">
                <CardMedia
                  component="img"
                  image={socketImage ? socketImage : videoImage}
                  className={
                    videoData?.isGenerated || generatedStatus
                      ? "videoCardImage"
                      : "blurImage"
                  }
                />
                <div className="videoLoadingContainer">
                  <Typography variant="body2" className="videoLoadingText">
                    {displayStatus}
                  </Typography>
                  {videoData?.status === "IN_PROGRESS" && (
                    <CircularProgress size={24} className="videoLoadingIcon" />
                  )}
                </div>
              </Box>
            )}
            {/* <Box className="videoDescription">
              <Typography variant="h6" className="videoTitle">
                Video Generated
              </Typography>
              <Chip
               label={
                (Array.isArray(allSearchImages)
                  ? allSearchImages.filter((item: any) => item?.isGenerated).length
                  : 0) ||
                (Array.isArray(videoData)
                  ? videoData.filter((item: any) => item?.isGenerated).length
                  : 0)
              }
                className="videoChip"
              />
            </Box> */}
            <Box className="videoThumbnails cinemotioncontainer">
              <FluidComponent
                items={allSearchImages.map((item: any) => ({
                  ...item,
                  thumbnailUrl: item?.thumbnailUrl || item?.inputData?.imageUrl || '',
                }))}
                selectedIndex={selectedVideoIndex}
                onSelect={(idx: number) => {
                  setSelectedImageId(allSearchImages[idx]._id);
                  handleVideoSearch(allSearchImages[idx]._id);
                  setSelectedVideoIndex(idx);
                }}
                isLoading={isWsLoading}
                onPromptClick={handleOpenPopup}
                viewType={viewType}
                setViewType={setViewType}
                headingText="VideoGenerated"
                chips={allSearchImages?.map((item:any)=>item.isGenerated).length}
              />
            </Box>
               <Dialog open={viewPopupOpen} onClose={() => setViewPopupOpen(false)} >
                                <Box className="PopupHeader">
                                    <IconButton onClick={() => setViewPopupOpen(false)} className="PopupCloseButton">
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <DialogTitle>Publish Youtube Info</DialogTitle>
                                <DialogContent>
                                    <Box sx={{ minWidth: 250, p: 1 }}>
                                        {Array.isArray(publishedData) && publishedData.length > 0 ? (
                                            publishedData.map((entry: any, idx: number) => (
                                                <Box key={idx} sx={{ mb: 2 }}>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Channel Name:<Typography variant='body1'>{entry.details?.snippet?.channelTitle || entry.channelId || ''}</Typography>
                                                    </Typography>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Published Status:<Typography variant='body1'>{entry.status || ''}</Typography>
                                                    </Typography>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Published Url: <Typography
                                                            variant="body1"
                                                            className="linkTextyoutube"
                                                            style={{ cursor: entry.youtubeUrl ? 'pointer' : 'default', color: entry.youtubeUrl ? '#1976d2' : undefined }}
                                                            onClick={() => {
                                                                if (entry.youtubeUrl) window.open(entry.youtubeUrl, '_blank');
                                                            }}
                                                        >
                                                            {entry.youtubeUrl || ''}
                                                        </Typography>
                                                    </Typography>
                                                </Box>

                                            ))
                                        ) : (
                                            <Typography variant="body1">No YouTube publish info available.</Typography>
                                        )}
                                    </Box>
                                </DialogContent>
                            </Dialog>
          </Box>
        ) : (
          <Card className="videoPlaceholderCard">
            <Box className="videoPlaceholderContent">
              <img
                src={'/assets/ContentVideo.svg'}
                alt="contentVideo"
                className="videoPlaceholderIcon"
              />
              <Typography variant="body1" className="videoPlaceholderText">
                Create your ideas now.
              </Typography>
              <Typography variant="body1" className="videoPlaceholderText">
                Generated videos will appear here
              </Typography>
            </Box>
          </Card>
        )}

        {/* {popup} */}
        {popupOpen && (
          <Popup
            open={popupOpen}
            onClose={() => setPopupOpen(false)}
            rightColumnType='video'
            leftColumnType='both'
            leftImageSrc={videoImage}
            mainVideo={mainVideo}
            leftPromptText={modalPrompt}
          />

        )}
        {Array.isArray(scheduledData) && scheduledData.length > 0 && (
          <ScheduledPopup
            open={true}
            onClose={() => setScheduleData(null)}
            scheduledData={scheduledData}
          />
        )}
      </Box>
    );
}